var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_37",
    filter: "url(#filter0_d_638_357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M122.894 86.7424C122.056 89.5724 121.423 91.6657 120.99 93.0453C120.853 93.4658 120.571 93.619 120.147 93.4935L96.6841 86.532C96.031 86.3386 95.9377 86.4855 96.4122 86.9874L113.28 104.77C113.593 105.099 113.592 105.61 113.262 105.923L103.63 115.047C103.341 115.31 102.906 115.306 102.643 115.016L85.9277 97.3915C85.4061 96.8383 85.2427 96.927 85.4113 97.6623L91.154 121.447C91.2283 121.743 91.0417 122.037 90.7455 122.111L77.5731 125.263C77.1305 125.369 76.8449 125.197 76.7392 124.755L71.1675 101.445C70.9548 100.522 70.7019 100.534 70.4202 101.485L63.6177 124.495C63.5397 124.759 63.3033 124.925 63.0856 124.861L49.9973 120.997C49.6421 120.892 49.429 120.517 49.5342 120.162L56.3312 97.2125C56.6196 96.2386 56.3994 96.0986 55.6556 96.8005L38.0466 113.544C37.8777 113.694 37.6167 113.691 37.4673 113.522L27.9445 103.511C27.7365 103.287 27.7398 102.939 27.9635 102.731L45.6696 85.9542C46.2263 85.4212 46.1295 85.243 45.3793 85.4196L21.5929 91.1238C21.3493 91.1888 21.0947 91.0386 21.0331 90.7836L17.789 77.3727C17.716 77.1143 17.881 76.8516 18.1509 76.782L42.1728 70.9979C42.9264 70.8099 42.9349 70.613 42.1901 70.3924L18.675 63.4403C18.4 63.3589 18.2387 63.0618 18.3202 62.7869C18.9399 60.6524 19.563 58.5064 20.2043 56.341C20.8457 54.1755 21.4917 52.0363 22.1343 49.9086C22.2192 49.6222 22.5128 49.4724 22.7878 49.5538L46.2995 56.5174C47.0443 56.738 47.1444 56.5682 46.6147 56.0001L29.6138 38.0786C29.4253 37.8732 29.43 37.5631 29.6319 37.3861L39.648 27.8901C39.8352 27.7212 40.1339 27.7224 40.3028 27.9095L57.1578 45.6507C57.6908 46.2073 57.869 46.1106 57.6924 45.3604L51.9671 21.6434C51.9042 21.3506 52.0795 21.0536 52.3756 20.9793L65.8145 17.7686C66.0318 17.7084 66.252 17.8484 66.3123 18.0656L71.963 41.6981C72.2045 42.6919 72.477 42.6978 72.754 41.7206L79.5509 18.7712C79.6561 18.416 80.0389 18.2178 80.3941 18.323L93.4756 22.2099C93.6933 22.2744 93.8041 22.5315 93.7227 22.8065L86.8973 45.8097C86.6305 46.7526 86.8244 46.8973 87.502 46.2506L104.873 29.7229C105.202 29.4093 105.535 29.4207 105.849 29.7504L115.18 39.5678C115.388 39.7914 115.385 40.1394 115.161 40.3473L97.4036 57.1716C96.8503 57.6932 96.9504 57.8599 97.6892 57.6799L121.295 51.9969C121.673 51.8971 122.052 52.1339 122.14 52.509L125.261 65.4098C125.359 65.8376 125.09 66.2814 124.648 66.3871L100.817 72.1156C100.145 72.2782 100.144 72.4522 100.797 72.6456L124.266 79.5841C124.69 79.7097 124.847 79.9804 124.729 80.4192C124.345 81.8008 123.732 83.9124 122.894 86.7424Z",
    fill: "#FF8E0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.2033 69.2307C63.6266 68.7513 63.0199 66.129 63.863 63.3665C64.7047 60.6086 66.6612 58.7578 68.2401 59.2379C69.8168 59.7174 70.4235 62.3397 69.5801 65.1034C68.7387 67.8601 66.7822 69.7108 65.2033 69.2307Z",
    fill: "#F6EEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M75.2549 72.171C73.6599 71.6986 73.0303 69.0695 73.8461 66.3151C74.6625 63.5584 76.6304 61.7111 78.2322 62.1855C79.8272 62.6579 80.4568 65.287 79.6411 68.0414C78.8246 70.7981 76.8567 72.6454 75.2549 72.171Z",
    fill: "#F6EEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.4341 86.716C60.9335 85.2669 56.8973 81.0308 55.4542 75.6587C55.1078 74.3659 54.9964 73.5814 55.1314 73.3083C56.6885 70.175 57.8199 70.2926 58.5203 73.6349C59.6202 78.9027 62.5568 82.1638 67.3071 83.4119C72.0658 84.6746 76.2141 83.2748 79.7721 79.2303C82.0413 76.6714 83.0684 77.1322 82.888 80.6219C82.8684 80.9259 82.3765 81.5612 81.4417 82.5106C77.5459 86.477 71.9461 88.1683 66.4341 86.716Z",
    fill: "#F6EEE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_638_357",
    x: 0.371729,
    y: 0.354639,
    width: 170.31,
    height: 170.339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_638_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_638_357",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.0473bc3417d81f08ca76ab4367c31a91.svg";
export { ForwardRef as ReactComponent };